export const BONUS_STATES = {
  CANCELLED: 'CANCELLED',
  CANCELLED_PENDING: 'CANCELLED_PENDING',
  CANCELLED_SETTLED: 'CANCELLED_SETTLED',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  WAITING_FOR_ACCRUAL: 'WAITING_FOR_ACCRUAL',
  SETTLED: 'SETTLED',
};
